import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./pages/static/ScrollToTop";

import Home from "./pages/static/Home";
import Layout from "./pages/static/Layout";
import AboutUs from "./pages/static/AboutUs";
import ContactUs from "./pages/static/ContactUs";
import Services from "./pages/static/Services";
import ServiceDetail from "./pages/static/ServiceDetail";
import NutritionAndDietetics from "./pages/static/NutritionAndDietetics";
import Login from "./pages/auth/Login";
import SetMpin from "./pages/auth/SetMpin";
import UpdatePatientProfile from "./pages/patient/UpdateProfile";
import DoctorDashboard from "./pages/doctor/Dashboard";
import DoctorUpdateProfile from "./pages/doctor/UpdateProfile";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminUserList from "./pages/admin/UserList";
import NotFound from "./pages/static/NotFound";
import Unauthorized from "./pages/static/Unauthorized";
import RedirectToWhatsApp from "./pages/static/RedirectToWhatsApp";
import DoctorsList from "./pages/patient/DoctorsList";
import BookDoctor from "./pages/patient/BookDoctor";
import PatientAppointments from "./pages/patient/PatientAppointments";
import DoctorAppointments from "./pages/doctor/DoctorAppointments";
import PatientsList from "./pages/doctor/PatientsList";
import PatientReports from "./pages/doctor/PatientReports";
import AppointmentList from "./pages/admin/AppointmentList";
import DashBoardLayout from "./pages/DashBoardLayout";
import DoctorsSlotList from "./pages/admin/DoctorsSlotList";
import { useAppSelector } from "./store/hooks";

const App: React.FC = () => {
  const { defaultRole } = useAppSelector((s) => s.auth);

  // console.log("User Roles in App.tsx:", user?.roles);

  const renderbasedOnRole = () => {
    if (defaultRole === "admin") {
      return (
        <Route
          path="/"
          element={
            <DashBoardLayout />
          }
        >
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="user-list" element={<AdminUserList />} />
          <Route path="appointment-list" element={<AppointmentList />} />
          <Route path="doctor-slot-list" element={<DoctorsSlotList />} />
        </Route>
      );
    } else if (defaultRole === "doctor") {
      return (
        <Route path="/" element={<DashBoardLayout />}>
          <Route path="dashboard" element={<DoctorDashboard />} />
          <Route path="update-profile" element={<DoctorUpdateProfile />} />
          <Route path="appointments" element={<DoctorAppointments />} />
          <Route path="patients" element={<PatientsList />} />
        </Route>
      );
    } else if (defaultRole === "patient") {
      return (
        <Route path="/" element={<DashBoardLayout />}>
          {/* <Route path="dashboard" element={<PatientDashboard />} /> */}
          <Route path="update-profile" element={<UpdatePatientProfile />} />
          <Route path="dashboard" element={<DoctorsList />} />
          <Route path="book-doctor/:id" element={<BookDoctor />} />
          <Route path="appointments" element={<PatientAppointments />} />
          <Route path="reports" element={<PatientReports />} />
        </Route>
      );
    }
    return null;
  };
  return (
    <BrowserRouter>
      {/* <AuthHandler /> */}
      <ToastContainer position="top-right" autoClose={3000} />
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/service-details/:slug" element={<ServiceDetail />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/nutrition-and-dietetics" element={<NutritionAndDietetics />} />
          {/* <Route path="/login" element={<Login />} /> */}
          <Route path="/appointment" element={<RedirectToWhatsApp />} />
          <Route path="/set-mpin" element={<SetMpin />} />
          <Route path="patients/:phone/reports" element={<PatientReports />} />

          {renderbasedOnRole()}

          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
